import { Plus } from "lucide-react";
import { Button } from "../ui/button";

export function ShoppingHeader({ uncheckedCount, checkedCount, onAddItem }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-3xl font-bold text-white font-['Outfit']">
          Shopping List
        </h1>
        <p className="text-slate-400 mt-1">
          {uncheckedCount} item{uncheckedCount !== 1 ? "s" : ""} to buy
          {checkedCount > 0 && ` • ${checkedCount} checked`}
        </p>
      </div>
      <Button
        onClick={onAddItem}
        className="bg-indigo-600 hover:bg-indigo-500 glow-primary"
        data-testid="add-item-button"
      >
        <Plus size={18} className="mr-2" />
        Add Item
      </Button>
    </div>
  );
}
